@if(datePickerMode === 'dropdown'){
<div class="date-group" [class.disabled]="isDisabled">
  <label [for]="resolvedDateKey">{{ resolvedDateLabel }}</label>
  <div class="date-dropdown">
    <input
      #dropdownInput
      readonly
      type="text"
      [id]="resolvedDateKey"
      [value]="dropdownValue"
      [ngClass]="{ custom: styleDropdown === 'custom' }"
      (click)="toggleDropdownCalendar()"
    />
    <mat-icon [class.rotated]="dropdownCalendarOpened" (click)="toggleDropdownCalendar(); $event.stopPropagation()"
      >expand_more</mat-icon
    >
  </div>
</div>

@if(dropdownCalendarOpened){
<div class="date-picker-container only-calendar" [class.disabled]="isDisabled" #dropdownCalendar>
  <div class="date-picker">
    <mat-calendar
      [selected]="calendarSelectedDate"
      [dateClass]="dateClass"
      [minDate]="minDate"
      [maxDate]="maxDate"
      (selectedChange)="onCalendarDateSelected($event)"
    >
    </mat-calendar>

    @if(selectionMode === 'range' && rangeErrorMessage){
    <div class="error-message">
      {{ rangeErrorMessage }}
    </div>
    }

    @if(showActions){
    <div class="dropdown-actions">
      <button type="button" class="cancel-btn" (click)="closeDropdownCalendar()">Close</button>
      <button type="button" class="apply-btn" [disabled]="!rangeStart" (click)="confirmDropdownSelection()">
        Confirm
      </button>
    </div>
    }
  </div>
</div>
} } @if(datePickerMode === 'menu'){
<!-- Trigger -->
<div
  class="date-picker-component"
  [matMenuTriggerFor]="dateMenu"
  #trig="matMenuTrigger"
  (click)="triggerDatePicker()"
  [class.disabled]="isDisabled"
>
  <span>{{ selectedPeriod }}</span>
  <svg
    class="icon"
    [style.transform]="trig.menuOpen ? 'rotate(180deg)' : ''"
    viewBox="0 0 11 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5.5 6L0 0.5H11L5.5 6Z" fill="#757575" />
  </svg>
</div>

<!-- Menu -->
<mat-menu #dateMenu="matMenu" class="custom-date-panel">
  <div class="date-picker-container" (click)="$event.stopPropagation()">
    <div class="date-picker-header">
      <p>Select a time period</p>
    </div>

    <!-- Preset chips -->
    <div class="date-chips">
      @if (showToday) {
        <span mat-button class="chip" [ngClass]="{ selected: selectedChip === 'Today' }" (click)="onChipClick('Today')"
          >Today</span
        >
      }
      <span mat-button class="chip" [ngClass]="{ selected: selectedChip === 'Week' }" (click)="onChipClick('Week')"
        >Week</span
      >
      <span mat-button class="chip" [ngClass]="{ selected: selectedChip === 'Month' }" (click)="onChipClick('Month')"
        >Month</span
      >
      <span
        mat-button
        class="chip"
        [ngClass]="{ selected: selectedChip === 'Quarter' }"
        (click)="onChipClick('Quarter')"
        >Quarter</span
      >
      <span mat-button class="chip" [ngClass]="{ selected: selectedChip === 'Year' }" (click)="onChipClick('Year')"
        >Year</span
      >
      @if (showAllTime) {
        <span
          mat-button
          class="chip"
          [ngClass]="{ selected: selectedChip === 'All time' }"
          (click)="onChipClick('All time')"
          >All time</span
        >
      }
      <span mat-button class="chip" [ngClass]="{ selected: selectedChip === 'Custom' }" (click)="onChipClick('Custom')"
        >Custom</span
      >
    </div>

    <!-- Date-range picker -->
    @if(showCalendar){
    <div class="date-picker">
      <mat-calendar
        [selected]="calendarSelectedDate"
        [dateClass]="dateClass"
        [minDate]="minDate"
        [maxDate]="maxDate"
        (selectedChange)="onCalendarDateSelected($event)"
      >
      </mat-calendar>
      @if(selectionMode === 'range' && rangeErrorMessage){
      <div class="error-message">
        {{ rangeErrorMessage }}
      </div>
      }
      @if(selectionMode === 'range'){
      <button
        type="button"
        class="apply-btn"
        [disabled]="!rangeStart || (!allowSingleInRange && !rangeEnd)"
        (click)="emitDateRange()"
      >
        Apply
      </button>
      }
    </div>
    }
  </div>
</mat-menu>
}
